import RestService from "@/services/RestService";

export default {
  state() {
    return {
      baseUrl: null,
      accessToken: null,
      user: null,
    };
  },
  getters: {},
  mutations: {
    setLunehubBaseUrl(state, payload) {
      state.baseUrl = payload;
    },
    setLunehubAccessToken(state, payload) {
      state.accessToken = payload;
    },
    setLunehubUser(state, payload) {
      state.user = payload;
    },
  },
  actions: {
    /** @param {{ baseUrl: string, accessToken: string, user: Record<string, any> }} payload */
    setLuneAuthData(context, payload) {
      context.commit("setLunehubBaseUrl", payload.baseUrl);
      context.commit("setLunehubAccessToken", payload.accessToken);
      RestService.updateBaseUrl(payload.baseUrl);
      context.commit("setLunehubUser", payload.user);
    },
  },
};
